import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SamplingKit, SamplingKitStatus } from 'src/shared/types';

export const defaultSamplingKit: SamplingKit = {
    id: '',
    name: '',
    barcode: '',
    latitude: '',
    longitude: '',
    sampler: '',
    sampledAt: '',
    sampledTime: '',
    habitat: '',
    notes: '',
    volumeFiltered: null,
    combinedVolumeFiltered: null,
    noOfSubSamples: null,
    preservationMethod: '',
    collectionMethod: '',
    samplingDuration: null,
    testTypes: [],
    status: SamplingKitStatus.READY_TO_SAMPLE,
};

export type SampleManifestState = {
    selectedSamplingEventId: string;
    selectedSamplingKitId: string;
    isTermsAndConditionsAccepted: boolean;
    isSamplingEventCompleted: boolean | null;
    isSavingSamplingKit: boolean;
};

export const initialState: SampleManifestState = {
    selectedSamplingEventId: '',
    selectedSamplingKitId: '',
    isTermsAndConditionsAccepted: false,
    isSamplingEventCompleted: null,
    isSavingSamplingKit: false,
};

export const sampleManifestSlice = createSlice({
    name: 'sampleManifest',
    initialState,
    reducers: {
        selectSamplingKit(state, action: PayloadAction<string>) {
            state.selectedSamplingKitId = action.payload;
        },
        setSelectedSamplingEventId(state, action: PayloadAction<string>) {
            state.selectedSamplingEventId = action.payload;
        },
        setTermsAndConditionsAccepted(state, action: PayloadAction<boolean>) {
            state.isTermsAndConditionsAccepted = action.payload;
        },
        setSamplingEventCompleted(state, action: PayloadAction<boolean | null>) {
            state.isSamplingEventCompleted = action.payload;
        },
        setIsSavingSamplingKit(state, action: PayloadAction<boolean>) {
            state.isSavingSamplingKit = action.payload;
        },
    },
});

export const {
    selectSamplingKit,
    setSelectedSamplingEventId,
    setTermsAndConditionsAccepted,
    setSamplingEventCompleted,
    setIsSavingSamplingKit,
} = sampleManifestSlice.actions;

export default sampleManifestSlice.reducer;
